import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import VersionSwitch from '../../components/shared/VersionSwitch';
import NotificationBell from '../../components/shared/NotificationBell';

export default function HeaderV2({ onToggleSidebar, sidebarCollapsed }) {
  const location = useLocation();

  const getBreadcrumbTitle = () => {
    const path = location.pathname;
    if (path === '/home') return 'Dashboard Principal';
    if (path.startsWith('/createinspection')) return 'Creación de Peritaje';
    if (path.startsWith('/modifyInspection')) return 'Modificar Peritaje';
    if (path.startsWith('/inspectionreport')) return 'Reportes de Peritaje';
    if (path.startsWith('/myschedule') || path.startsWith('/schedule')) return 'Agendamiento';
    if (path.startsWith('/users')) return 'Gestión de Usuarios';
    if (path.startsWith('/orders')) return 'Órdenes de Servicio';
    if (path.startsWith('/criticalplates')) return 'Placas Críticas';
    if (path.startsWith('/payments')) return 'Reporte de Pagos';
    if (path.startsWith('/pqr')) return 'Gestión PQR';
    if (path.startsWith('/inspectionauth')) return 'Autorizaciones de Peritaje';
    if (path.startsWith('/inspectionstates')) return 'Reapertura de Peritaje';
    if (path.startsWith('/inspectionmodify')) return 'Modificación de Peritaje';
    if (path.startsWith('/bireport')) return 'Reportes BI';
    if (path.startsWith('/sendannouncement')) return 'Envío de Anuncios';
    return 'Sistema de Peritaje';
  };

  return (
    <header className="v2-header">
      <div className="v2-header-left">
        <button
          type="button"
          className="v2-collapse-btn"
          onClick={onToggleSidebar}
          title={sidebarCollapsed ? 'Expandir menú' : 'Colapsar menú'}
        >
          <FaBars />
        </button>

        <div className="v2-breadcrumbs">
          <span className="text-muted d-none d-sm-inline">/</span>
          <span className="v2-breadcrumb-current text-truncate" title={getBreadcrumbTitle()}>{getBreadcrumbTitle()}</span>
        </div>
      </div>

      <div className="v2-header-right">
        <VersionSwitch variant="header" />

        <NotificationBell variant="v2" />
      </div>
    </header>
  );
}
